// ==============================
// CONFIG: DETECTAR ENTORNO
// ==============================
const isProd = window.location.hostname === "inventario.ip-depot.com.mx";

// ==============================
// DOMINIO COGNITO (NO CAMBIA)
// ==============================
export const COGNITO_DOMAIN =
  "https://us-east-1s6zs9wb29.auth.us-east-1.amazoncognito.com";

// App Client ID (el mismo para dev y prod)
export const COGNITO_CLIENT_ID = "4lvjps8kt64o9rdildnl3ogg4b";

// ==============================
// CALLBACKS
// ==============================
export const REDIRECT_URI = isProd
  ? "https://inventario.ip-depot.com.mx/callback"
  : "http://localhost:3000/callback";

// ==============================
// LOGIN URL
// ==============================
export function getLoginUrl() {
  const scopes = encodeURIComponent("openid email");

  return `${COGNITO_DOMAIN}/login?client_id=${COGNITO_CLIENT_ID}&response_type=code&scope=${scopes}&redirect_uri=${encodeURIComponent(
    REDIRECT_URI
  )}`;
}

// ==============================
// LOGOUT URL
// ==============================
export function getLogoutUrl() {
  const logoutUri = isProd
    ? "https://inventario.ip-depot.com.mx/"
    : "http://localhost:3000/";

  return `${COGNITO_DOMAIN}/logout?client_id=${COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(
    logoutUri
  )}`;
}
